import { render, staticRenderFns } from "./LpPortfolios.vue?vue&type=template&id=402a5852&scoped=true"
import script from "./LpPortfolios.vue?vue&type=script&lang=js"
export * from "./LpPortfolios.vue?vue&type=script&lang=js"
import style0 from "./LpPortfolios.vue?vue&type=style&index=0&id=402a5852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a5852",
  null
  
)

export default component.exports